// The page's own messages for its script, in the page's language: the
// server writes them into <script id="mk-i18n" type="application/json">,
// each Fluent variable left as a `{name}` placeholder. A message the page
// does not ship comes back as its id, which a test would catch first.
let messages;

function catalogue() {
    if (messages) return messages;
    try {
        messages = JSON.parse(document.getElementById("mk-i18n")?.textContent || "{}");
    } catch {
        messages = {};
    }
    return messages;
}

export function lang() {
    return document.documentElement?.lang || "en";
}

// The viewer's own locale when it is in the page's language (en-GB on an
// English page keeps its 24-hour clock, pt-PT on a pt-BR page its own
// dates), else the page's language; for dates and times, which the server
// never renders.
export function locale() {
    const own = typeof navigator === "undefined" ? [] : navigator.languages || [];
    const language = (tag) => tag.split("-")[0].toLowerCase();
    return own.find((tag) => language(tag) === language(lang())) || lang();
}

const rules = {};

function pluralRules(type) {
    return (rules[type] ??= new Intl.PluralRules(lang(), { type }));
}

// With a numeric `count`, an id that has no message of its own picks its
// plural form, `<id>-one`, `<id>-other` or another the language has; with a
// numeric `rank`, its form for 1st, 2nd, 3rd the same way (`-one` for 1st,
// `-two` for 2nd in English).
export function t(id, args = {}) {
    const all = catalogue();
    let key = id;
    const type = typeof args.count === "number" ? "cardinal" : typeof args.rank === "number" ? "ordinal" : null;
    if (!(id in all) && type) {
        const form = pluralRules(type).select(type === "cardinal" ? args.count : args.rank);
        key = `${id}-${form}` in all ? `${id}-${form}` : `${id}-other`;
    }
    const text = all[key] ?? id;
    return text.replace(/\{(\w+)\}/g, (whole, name) => (name in args ? String(args[name]) : whole));
}

// Languages that write every noun with a capital, so a phrase keeps its
// first letter mid-sentence ("Montag"). Locale::capitalizes_nouns holds
// the same list for the server.
const NOUN_CAPITALS = ["de"];

// `phrase` as it reads joined into a sentence: its first letter lowered,
// except in a language whose nouns keep their capital.
export function midSentence(phrase) {
    if (!phrase || NOUN_CAPITALS.includes(lang())) return phrase;
    return phrase.charAt(0).toLowerCase() + phrase.slice(1);
}

// A number as the page's language writes it: grouping and decimal mark.
export function number(n, options) {
    return new Intl.NumberFormat(lang(), options).format(n);
}
